// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"75bc8b49","239":"eabe7e28","453":"ed14f1ec","732":"1f9c6b9c"}[chunkId] + ".chunk.js";
};